import {
  addUser,
  removeUser,
  authorised,
  addLoaderLoading,
  removeLoaderLoading,
} from "../constants/userConstant";
export const AddUser = (details) => {
  return {
    type: addUser,
    payload: {
      userDetails: details,
    },
  };
};

export const RemoveUser = () => {
  return {
    type: removeUser,
    payload: {
      userDetails: null,
    },
  };
};

export const ChangeAuthentication = () => {
  return {
    type: authorised,
  };
};

export const AddLoadingLoader = () => {
  return {
    type: addLoaderLoading,
  };
};

export const RemoveLoadingLoader = () => {
  return {
    type: removeLoaderLoading,
  };
};
